export default __webpack_public_path__ + "assets/icons/check-mark.77ea692a.svg";